import { Component, OnDestroy, inject } from '@angular/core';

import { BellNotficationService } from '../../services/bell-notification.service';
import { EmployeeInfoService } from '../../services/employee-info.service';
import { UtilityService } from '../../services/utility.service';
import { ApiResponse } from '../../../shared/model/api-response.model';

@Component({
  selector: 'app-bell-notification',
  templateUrl: './bell-notification.component.html',
  styleUrls: ['./bell-notification.component.css'],
})
export class BellNotificationComponent implements OnDestroy {
  private readonly employeeInfoService = inject(EmployeeInfoService);
  private readonly utilityService = inject(UtilityService);
  public readonly bellNotficationService = inject(BellNotficationService);

  readonly employeeInfo = this.employeeInfoService.getEmployeeInfo();
  readonly dateFormat = this.utilityService.getDateFormat().toLowerCase().replace('mm', 'MM') + ' h:mm:ss a';
  readonly isMobile = this.utilityService.isMobileMode();

  public ngOnDestroy(): void {
    this.bellNotficationService.onDestroy();
  }

  onclickBellNotificationDropdown(): void {
    this.bellNotficationService.hasNewNotification = false;
  }

  executeActionURL(event: Event, bellNotificationId: bigint, actionURL: string, status: number): void {
    if (status != 1 || actionURL == null) {
      // prevent dropdown from closing
      event.stopPropagation();
      return;
    }

    if (this.bellNotficationService.bellNotifications.length > 1) {
      // prevent dropdown from closing
      event.stopPropagation();
    }

    this.bellNotficationService.executeActionURL(this.employeeInfo.UserKeyID, bellNotificationId, actionURL);
  }

  dismissBellNotification(event: Event, bellNotificationId: bigint): void {
    if (this.bellNotficationService.bellNotifications.length > 1) {
      // prevent dropdown from closing
      event.stopPropagation();
    }

    this.bellNotficationService.dismissBellNotification(this.employeeInfo.UserKeyID, bellNotificationId).then((response: ApiResponse) => {
      if (response.success) {
        this.bellNotficationService.removeBellNotification(bellNotificationId);
      }
    });
  }
}
